import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { accountByActiveByNameDropDown } from "../../graphql/account/account-queries";

import { TextField, CircularProgress } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { useNotify } from "react-admin";

import { accountNameRenderer } from "./AccountNameRenderer";
import { logError } from "../../utils/appUtils";

const getAccounts = async (
  setAccounts,
  notify,
  setFetching,
  onAccountsLoaded,
) => {
  try {
    const response = await API.graphql(
      graphqlOperation(accountByActiveByNameDropDown, {
        reloadYardId: window.appUser?.reloadYardId,
        activeBusinessName: { beginsWith: { active: "true" } },
        limit: 1000,
      }),
    );
    const accounts = response.data.accountByActiveByName.items;
    setAccounts(accounts);
    if (onAccountsLoaded) {
      onAccountsLoaded(accounts);
    }
    setFetching(false);
  } catch (err) {
    logError("common:AccountDropDown:getAccounts", err, notify);
  }
};

export const MuiAccountDropDown = ({
  label = "Account",
  disabled = false,
  required,
  value,
  onChange,
  onAccountsLoaded,
  ...props
}) => {
  const notify = useNotify();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAccounts(setAccounts, notify, setLoading, onAccountsLoaded);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onAccountsLoaded]);

  useEffect(() => {
    if (accounts.length > 0 && value?.id && !value?.businessName) {
      const defaultAccount = accounts.find((itm) => itm.id === value.id);
      onChange(defaultAccount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, accounts]);

  const handleChange = (_, selected) => {
    onChange(selected || null);
  };

  return (
    <Autocomplete
      {...props}
      size="small"
      options={accounts}
      value={value || null}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : accountNameRenderer(option)
      }
      // getOptionSelected={(option, value) => option.id === value.id}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      onChange={handleChange}
      loading={loading}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          label={label}
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
